import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-137b4926"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "header-logo-wp"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "header-logo"
}, null, -1));
const _hoisted_4 = {
  class: "header-logo-text"
};
const _hoisted_5 = {
  class: "header-right"
};
const _hoisted_6 = {
  class: "avatar-name"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;"
}, "个人中心", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;"
}, "查看通知", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "separator"
}, null, -1));
import { getCurrentInstance, h, ref } from 'vue';
import { AppstoreOutlined, DownOutlined, HomeOutlined, SettingOutlined } from '@ant-design/icons-vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores';

import { toRefs, watch, onMounted } from 'vue';
export default {
  __name: 'index',
  emits: ['siderVisible'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const isntance = getCurrentInstance();
    const router = useRouter();
    const userStore = useUserStore();
    const {
      username
    } = toRefs(userStore);
    const title = window.defaultSettings.title;
    const current_header_nav = ref([]);
    const items_header_nav = ref([{
      key: 'home',
      icon: () => h(HomeOutlined),
      label: '首页',
      title: '首页'
    }, {
      key: 'console',
      icon: () => h(AppstoreOutlined),
      label: '控制台',
      title: '控制台'
    }, {
      key: 'system',
      icon: () => h(SettingOutlined),
      label: '系统管理',
      title: '系统管理'
    }]);
    watch(() => current_header_nav.value[0], toPath => {
      emits('siderVisible', toPath);
    }, {
      deep: true
    });
    onMounted(() => {
      const matched = router.currentRoute.value.matched ?? [];
      const parentRoute = matched[1];
      const currentName = parentRoute.name;
      current_header_nav.value[0] = currentName;
    });
    function handleClickHeaderNav(e) {
      const {
        key
      } = e;
      if (key == 'home') router.push('/home');else if (key == 'console') router.push('/console');else if (key == 'system') router.push('/admin');
    }
    function clickLogout() {
      isntance.proxy.logout();
    }
    return (_ctx, _cache) => {
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_avatar = _resolveComponent("a-avatar");
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      const _component_a_space = _resolveComponent("a-space");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(title)), 1)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_a_menu, {
        selectedKeys: current_header_nav.value,
        "onUpdate:selectedKeys": _cache[0] || (_cache[0] = $event => current_header_nav.value = $event),
        class: "header-nav-menu",
        mode: "horizontal",
        items: items_header_nav.value,
        onClick: handleClickHeaderNav
      }, null, 8, ["selectedKeys", "items"]), _createVNode(_component_a_space, {
        style: {
          "display": "flex",
          "flex-wrap": "wrap"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_a_avatar, {
          src: require('../../assets/images/ico-avatar.png')
        }, null, 8, ["src"]), _createVNode(_component_a_dropdown, {
          placement: "bottom",
          arrow: {
            pointAtCenter: true
          },
          "overlay-style": {
            'width': '100px',
            'margin-right': '10px'
          }
        }, {
          overlay: _withCtx(() => [_createVNode(_component_a_menu, null, {
            default: _withCtx(() => [_createVNode(_component_a_menu_item, null, {
              default: _withCtx(() => [_hoisted_7]),
              _: 1
            }), _createVNode(_component_a_menu_item, null, {
              default: _withCtx(() => [_hoisted_8]),
              _: 1
            }), _hoisted_9, _createVNode(_component_a_menu_item, null, {
              default: _withCtx(() => [_createElementVNode("a", {
                href: "javascript:;",
                onClick: clickLogout
              }, "退出登录")]),
              _: 1
            })]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("a", _hoisted_6, [_createTextVNode(_toDisplayString(_unref(username)), 1), _createVNode(_unref(DownOutlined))])]),
          _: 1
        })]),
        _: 1
      })])]);
    };
  }
};